import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { transactionSyncSchemaObject } from '../transactionSyncSchema';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi, { date } from '@hapi/joi'
import { PageHeader } from '../../../Common';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';

const screenCode = 'SYNCTRANSACTIONNS';

export function TransactionSyncAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Transaction Sync");
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [divisions, setDivisions] = useState()
    const [syncData, setSyncData] = useState({
        groupID: "0",
        operationEntityID: "0",
        masterDataTypeID : "0",
        transactionTypeID: "0",
        divisionID: "0",
        date: ""
    });
    const [buttonName, setButtonName] = useState("Sync");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(transactionSyncSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [syncData.groupID])

    useEffect(() => {
        trackPromise(
            getDivisions()
        )
    }, [syncData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITSYNCTRANSACTIONS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });


        if (data && edit) {
            setTitle("Edit syncData");
            setSyncData(data);
            setButtonName("Update");
            
        } else {
            
            setTitle("Transaction Sync");
            var token = tokenService.getUserDetailsFromToken();
            setSyncData({
                ...syncData,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }
        trackPromise(
            getAllGroups()
        )
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            operationEntityID: target.value,
            collectionPointID: '0'
        })
    }

    function handleCollectionPointDropdown(target) {
            validateInputs(target);

        setSyncData({
            ...syncData,
            divisionID: target.value
        })

    }

     function handleTransactionType(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            transactionTypeID: target.value,
        });
    }

    function handleFromDate(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            date: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, transactionSyncSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    async function handleSave(e) {

        const response = await services.syncData(syncData);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(syncData.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getDivisions() {
        const result = await services.getDivisions(syncData.operationEntityID)
        setDivisions(result)
    }


    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setSyncData({
            ...syncData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            transactionTypeID: 0,
            divisionID: 0,
            date: ""
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/syncTransaction"

                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={syncData.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={syncData.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>


                                    <div className="col-md">
                                        <InputLabel shrink id="transactionTypeID">Transaction Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="transactionTypeID"
                                            id="transactionTypeID"
                                            name="transactionTypeID"
                                            value={syncData.transactionTypeID}
                                            onChange={(e) => handleTransactionType(e.target)}
                                        >
                                            <MenuItem value="0">--Transaction Type--</MenuItem>
                                            <MenuItem value="1">Checkroll</MenuItem>
                                            <MenuItem value="2">Overtime</MenuItem>
                                            <MenuItem value="3">Outgrower</MenuItem>
                                            <MenuItem value="4">Bought Leaf</MenuItem>

                                        </Select>
                                        {errors["transactionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["transactionTypeID"]}</FormHelperText>}
                                    </div>
                                    {syncData.transactionTypeID != '4' ?
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={syncData.divisionID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || syncData.transactionTypeID == '4'}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    : null}     

                    
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="date"> Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDate(e.target)}
                                            value={syncData.date}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>}

                                    </div>
                                </div>

                                <MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        //onClick={handleSave}
                                        onClick={(e) => trackPromise(handleSave(e))}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}